<template>
  <div>
    <template v-if="includePostOrder">
      <PostOrder
        class="post-order-component"
        @order-posts="passOrderPostsToParent"
      />
    </template>
    <div
      class="post-container"
      :class="postType"
    >
      <PostTop
        :post="post"
        :is-post-with-image="isPostWithImage"
      />
      <PostMiddle
        :post="post"
        :is-post-with-image="isPostWithImage"
      />
      <PostBottom
        :post="post"
        :is-post-with-image="isPostWithImage"
      />
    </div>
  </div>
</template>

<script>
import PostOrder from '@/components/Post/PostOrder';
import PostTop from '@/components/Post/PostTop';
import PostMiddle from '@/components/Post/PostMiddle';
import PostBottom from '@/components/Post/PostBottom';

export default {
  name: 'Post',
  components: {
    PostOrder,
    PostTop,
    PostMiddle,
    PostBottom,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    includePostOrder: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPostWithImage() {
      return Boolean(this.post.image_url);
    },
    postType() {
      if (this.isPostWithImage) return 'post-type--image';
      return 'post-type--regular';
    },
  },
  methods: {
    passOrderPostsToParent(orderType) {
      this.$emit('order-posts', orderType);
    },
  },
};
</script>

<style scoped lang="scss">
  .post-order-component {
    margin-bottom: 20px;
  }

  .post-container {
    display: inline-grid;
    grid-template-columns: 1fr;
    vertical-align: top;
  }

  .post-type--regular {
    grid-template-rows: 205px auto 128px;
    width: 100%;
  }

  .post-type--image {
    grid-template-rows: 275px auto 128px;
    width: 100%;
  }

  @media screen and (max-width: 600px) {
    .post-container {
      width: 200px;
    }
  }
</style>
